import { API_ENDPOINT } from 'common/variables';

const handleApiError = async (response) => {
  if (!response.ok) {
    const errorData = await response.json();
    const error = {
      response: {
        status: response.status,
        data: errorData
      }
    };

    if (response.status === 401 || response.status === 400) {
      if (errorData.detail === 'User inactive or deleted.' || response.status === 401) {
        localStorage.setItem('authError', errorData.detail || 'Authentication failed');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        // Also clear hijack tokens
        localStorage.removeItem('hijackToken');
        localStorage.removeItem('hijackUserObj');
        localStorage.removeItem('hijackUser');
        // Don't redirect to 401 automatically - let the component handle it
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
  return response;
};

export async function api(endpoint, params = {}, token = null) {
  if (token) {
    if (!params.headers) params.headers = {};
    params.headers['Authorization'] = `Token ${token}`;
  }

  try {
    const response = await fetch(`${API_ENDPOINT}/${endpoint}`, params);
    return await handleApiError(response);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function get(endpoint, params = {}, token = null) {
  params.method = 'GET';
  return await api(endpoint, params, token);
}

export async function post(endpoint, params = {}, token = null) {
  params.method = 'POST';
  return await api(endpoint, params, token);
}

export async function put(endpoint, params = {}, token = null) {
  params.method = 'PUT';
  return await api(endpoint, params, token);
}

export async function patch(endpoint, params = {}, token = null) {
  params.method = 'PATCH';
  return await api(endpoint, params, token);
}

export async function destroy(endpoint, params = {}, token = null) {
  params.method = 'DELETE';
  return await api(endpoint, params, token);
}

export async function authUser(token) {
  const response = await api('api/v1/auth/user/', {
    headers: {
      'Content-Type': 'application/json',
    },
  }, token);
  return await response.json();
}

export async function googleLogin(credentialResponse) {
  try {
    const id_token = credentialResponse.credential;
    const response = await api('api/v1/auth/google/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({"access_token": id_token}),
    });
    const data = await response.json();
    return data.key;
  } catch (error) {
    console.error('Google login error:', error);
    throw error;
  }
}

export async function gmailAuthorize(token) {
  try {
    const response = await api('api/v1/gmail-auth/', {
      headers: {
        'Content-Type': 'application/json',
      },
    }, token);
    const data = await response.json();
    if (data.need_authorization) {
      window.open(data.auth_url, "_blank");
    }
  } catch (error) {
    console.error('Gmail authorize error:', error);
    throw error;
  }
}